<script>
export default {
  name: 'LoadingContainer',

  props: {
    isLoaded: {
      type: [Boolean, Number],
      default: 0
    },

    total: {
      type: Number,
      default: 0
    },

    kind: {
      type: String,
      default: 'Records'
    },

    size: {
      type: String,
      default: '3rem'
    }
  },

  render (createElement) {
    const loading = createElement('div', {
      class: 'loading-container__spinner',
      style: {
        '--lc-size': this.size
      }
    })
    const none = createElement('div',
      {
        class: 'loading-container',
        style: {
          '--lc-justify': this.$slots.button ? 'space-between' : 'center'
        }
      },
      [
        createElement('div', {
          class: 'loading-container__none',
          style: {
            '--lc-size': this.size
          }
        }, `No ${this.kind} Found`),
        this.$slots.button
      ]
    )

    if (!this.isLoaded) return loading

    if (this.total) return this.$slots.default

    return none
  }
}
</script>

<style lang="scss">
.loading-container {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: var(--lc-justify);
}

.loading-container__spinner {
  margin: 1rem auto;
  width: var(--lc-size);
  height: var(--lc-size);
  display: block;
  border-radius: var(--lc-size);
  border: .25rem solid #bbb;
  border-top-color: #444;
  animation: spin 2s linear infinite;
}

.loading-container__none {
  min-height: var(--lc-size);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
